import {FormFieldT, FormStepT} from '@/lib/types/form.types';

type UpdatePasswordFormDataT = {
  password: string;
  confirmPassword: string;
};

/****************************************************************************
 * Form Fields
 ****************************************************************************/
export const updatePasswordFormFields: FormFieldT<UpdatePasswordFormDataT>[] = [
  {
    label: 'Password',
    name: 'password',
    type: 'password',
    placeholder: 'Password',
    options: {
      required: 'Password is required',
      minLength: {
        value: 6,
        message: 'Password must be at least 6 characters',
      },
    },
    watch: {
      enabled: true,
      onChange: ({formContext}) => {
        // When password changes, validate confirmPassword if it has a value
        const confirmPassword = formContext.getValues('confirmPassword');
        if (confirmPassword) {
          formContext.trigger('confirmPassword');
        }
      },
    },
  },
  {
    label: 'Confirm Password',
    name: 'confirmPassword',
    type: 'password',
    placeholder: 'Confirm password',
    options: {
      required: 'Please confirm your password',
      validate: (value, formValues) => {
        if (!value) return true; // Let required handle empty case
        return value === formValues.password || 'Passwords do not match';
      },
    },
  },
];

export type UpdatePasswordFieldNamesT = (typeof updatePasswordFormFields)[number]['name'];

/****************************************************************************
 * Form Steps
 ****************************************************************************/
export const updatePasswordFormSteps: FormStepT<UpdatePasswordFieldNamesT> = [
  {
    step: 0,
    label: 'Update Password',
    fields: ['password', 'confirmPassword'],
  },
];
